import { Grid, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';

const image = require('./undraw_loading.svg');

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(4)
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  }
}));

const Loading = (props: { message?: string }) => {
  const classes = useStyles();
  const message = props.message? props.message : 'please wait';

  return (
    <div className={classes.root}>
      <Grid container justify="center" spacing={4}>
        <Grid item lg={6} xs={12}>
          <div className={classes.content}>
            <Typography variant="h1">Loading...</Typography>
            <Typography variant="subtitle2">
              {message}
            </Typography>
            <img alt="loading" className={classes.image} src={image}/>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default Loading;
